const STRINGS = {
  currentlySelectedItems: "Currently Selected Items",
  unselectAllItems: "Unselect all items",
  unselectAllOnThisPage: "Unselect all on this page",
  itemsSelected: "items selected",
  selectAllItems: "Select all items",
  selectAllOnThisPage: "Select all on this page",
  selectAllButton: "Select All,"
};
export default STRINGS;